import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatDate, limitParagraphByCharLimit } from "../../Helper/Helper";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import Spinner from "../Spinner";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function BlogListing() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [blogsData, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getBlogsData();
  }, []);

  const getBlogsData = async () => {
    setLoading(true);
    try {
      const response = await SendPostRequest("blogs/list");
      setBlogsData(response?.data);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
         <TextMainBannerWrapper Heading="Blogs" Image="theme-2-banner-blog.webp"/>

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "300px" }}
          >
            <Spinner />
          </div>
        ) : blogsData?.length > 0 ? (
          <section className="blog-section pad-top-80 pad-bottom-80 full-dark">
            <div className="container">
              {blogsData?.length > 0 ? (
                <div className="row">
                  <div className="col-md-8">
                    <div
                      className="blog-main-wrapper blog-style-5 margin-bottom-30"
                      data-animation="fadeInDown"
                    >
                      <div className="blog-inner blog-listing-inner">
                        <div className="blog-thumb relative mb-4">
                          <img
                            src={blogsData[0]?.image}
                            className="img-fluid blog-listimg-mobile"
                            style={{ height: "auto", width:"100%" }}
                            alt="blog-img"
                          />
                          <div className="blog-details pt-2 pb-0" >
                            <div className="top-meta mb-1">
                              <ul className="top-meta-list">
                                <li>
                                  <div className="post-date">
                                    <a href="#">
                                      <i className="ti-calendar theme-color me-1"></i>{" "}
                                      {formatDate(blogsData[0]?.date)}
                                    </a>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="blog-title">
                              <h5 className="margin-bottom-5">
                                <Link
                                  to={`/blog/detail/${blogsData[0]?.slug}`}
                                  className="blog-name"
                                >
                                  {blogsData[0]?.title}
                                </Link>
                              </h5>
                            </div>
                            <div className="blog-link">
                              <Link
                                to={`/blog/detail/${blogsData[0]?.slug}`}
                                className="link font-w-500"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {blogsData?.slice(1)?.map((data, index) => (
                    <div
                      key={index}
                      className="col-md-4"
                      data-animation="fadeInDown"
                    >
                      <div
                        className="blog-main-wrapper blog-style-5 margin-bottom-30"
                        style={{ height: "480px" }}
                      >
                        <div className="blog-inner blog-listing-inner">
                          <div className="blog-thumb relative mb-4">
                            <img
                              src={data?.image}
                              className="img-fluid"
                              style={{ height: "auto", width: "100%" }}
                              alt="blog-img"
                            />
                          </div>
                          <div className="blog-details pt-0 pb-0">
                            <div className="top-meta mb-1">
                              <ul className="top-meta-list">
                                <li>
                                  <div className="post-date">
                                    <a href="#">
                                      <i className="ti-calendar theme-color me-1"></i>
                                      {formatDate(data?.date)}
                                    </a>
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="blog-title">
                              <h5 className="margin-bottom-5">
                                <Link
                                  to={`/blog/detail/${data?.slug}`}
                                  className="blog-name"
                                >
                                  {data?.title}
                                </Link>
                              </h5>
                            </div>
                            <div className="post-desc mt-2">
                              {/* <p
                                dangerouslySetInnerHTML={{
                                  __html:
                                    data?.short_content
                                      ?.split(/\s+/)
                                      .slice(0, 16)
                                      .join(" ") + "...",
                                }}
                              /> */}

                              <p
                                dangerouslySetInnerHTML={{
                                  __html:
                                    limitParagraphByCharLimit(
                                      data?.short_content,
                                      85
                                    ) + "...",
                                }}
                              />

                              <div className="blog-link">
                                <Link
                                  to={`/blog/detail/${data?.slug}`}
                                  className="link font-w-500"
                                >
                                  Read More
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="col-12 text-center">
                  <h4>No Record Available</h4>
                </div>
              )}
            </div>
          </section>
        ) : (
          <div className="col-12 text-center my-5 py-5">
            <h4>No Record Available</h4>
          </div>
        )}

        <FooterWrapper />
      </div>
    </div>
  );
}

export default BlogListing;
